import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './lib/router';

export default function App() {
  useEffect(() => {
    // Debug: Log current path for troubleshooting
    console.log('App loaded with path:', window.location.pathname);
    console.log('App loaded with href:', window.location.href);

    // Track initial page load
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-VYPNQ64CDQ', {
        page_path: window.location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}